var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insights"},[_c('v-container',{attrs:{"fluid":""}},[_c('dynamic-insights')],1),_c('v-container',{attrs:{"fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }